import { Main } from "components/aud/base/Main";
import { Section } from "components/aud/base/Section";
import Head from "next/head";
import { PageTitle } from "components/aud/ui/PageTitle";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import { HomePageLink } from "~/components/links/HomePageLink";

const LawPage = ({ law }) => {
  return (
    <Main nav="policies">
      <Head>
        <title>NowDo 特定商取引法に基づく表示</title>
      </Head>
      <Section withInner>
        <PageTitle title="Legal Details" sub="特定商取引法に基づく表示" />
        <div className="_markdown">
          <ReactMarkdown rehypePlugins={[rehypeRaw]}>{law}</ReactMarkdown>
          <p>
            <HomePageLink
              aProps={{
                className: "_button primary",
              }}
            >
              トップページへ戻る
            </HomePageLink>
          </p>
        </div>
      </Section>
    </Main>
  );
};

export default LawPage;

export async function getStaticProps() {
  const content = await require(`../docs/law.md`);

  return {
    props: {
      law: content.default,
    },
  };
}
